const UNITS = {
  px: 1,
  mm: 25.4,
  cm: 2.54,
  in: 1,
  pt: 72,
  pc: 6,
};

export function unitToPx({ unit = 'px', dpi = 72, unitVal = 0 }) {
  if (unit === 'px') return unitVal;
  if (unit === 'in') return unitVal * dpi;
  if (unit === 'mm') return (unitVal / 25.4) * dpi;
  if (unit === 'cm') return (unitVal / 2.54) * dpi;
  if (unit === 'pt') return (unitVal / 72) * dpi;
  if (unit === 'pc') return (unitVal / 6) * dpi;
  return unitVal;
}

export function pxToUnit({ unit = 'px', dpi = 72, pxVal = 0 }) {
  if (unit === 'px') return pxVal;
  if (unit === 'in') return pxVal / dpi;
  if (unit === 'mm') return (pxVal / dpi) * 25.4;
  if (unit === 'cm') return (pxVal / dpi) * 2.54;
  if (unit === 'pt') return (pxVal / dpi) * 72;
  if (unit === 'pc') return (pxVal / dpi) * 6;
  return pxVal;
}
